import { createApp, createVNode } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-plus/dist/index.css";

import * as Icons from "@element-plus/icons-vue";

import { MotionPlugin } from "@vueuse/motion";

// rem
const width = document.documentElement.clientWidth || document.body.clientWidth;
const pageScale: string = width <= 1920 ? "1" : (width / 1920).toFixed(2);
document.documentElement.style.fontSize = pageScale + "px";

const app: any = createApp(App);
// 设置全局变量
app.config.globalProperties.$pageScale =
  width <= 1280 ? "1" : (width / 1920).toFixed(2);

app.use(MotionPlugin);

for (const [key, component] of Object.entries(Icons)) {
  app.component(key, component);
}
app.use(store).use(router).mount("#app");
